import axiosIns from '@/services/axios/axios'
import axiosFlowIns from '@/services/axios/axiosFlow'

export default class AuthService {
  static async isTokenValid() {
    try {
      await axiosIns.post('auth/login/validate')
      return true
    } catch {
      return false
    }
  }

  static async loginComEmailSenha(body) {
    return axiosFlowIns.post('clientes/login', body).then(res => res.data.data)
  }

  // Autenticado pelo token que o login acabou de emitir -- o axiosFlowIns já manda o Bearer salvo em useLocalStorage.
  static async completarCadastroAutoatendimento(body) {
    return axiosFlowIns.post('clientes/completar-cadastro-autoatendimento', body).then(res => res.data.data)
  }
}
